<template>
  <div class="bq-news" :class="{ mobile: isMobile }">
    <!-- 列表模式 -->
    <box class="bq-box" v-show="mode === 'list'">
      <card
        class="bq-box-item"
        layout="horizontal"
        size="middle"
        v-for="(item, index) in newsData.news"
        :key="index"
        :cover="item.cover"
        :title="item.title"
        :link="item.path"
        isLink
        @click.native="showLists(index)"
      >
        <p class="bq-box-item-tag" slot="tag">{{ item.time }}</p>
        <p class="bq-box-item-content" slot="content">{{ item.desc }}</p>
      </card>
    </box>

    <!-- 详情模式 -->
    <div class="mode-lists" v-if="mode === 'detail'">
      <tab class="tabs" :tabs="newsData.news" :default-active="listsIndex" />
    </div>
  </div>
</template>

<script>
import Box from '@/components/Box';
import Card from '@/components/website_v3/Card';
import Tab from '@/components/Tab';

import { newsData } from './news.js';
import { isWirelessDevice } from '@/utils/utils.js';

export default {
  name: 'news',

  components: {
    Box,
    Card,
    Tab,
  },

  data() {
    const { query } = this.$route;
    return {
      isMobile: false,
      mode: query.post ? 'detail' : 'list',
      listsIndex: query.post ? Number(query.post) - 1 : 0,
      newsData,
    };
  },

  created() {
    this.isMobile = isWirelessDevice();
  },

  methods: {
    showLists(index) {
      this.mode = 'detail';
      this.listsIndex = index;

      if (this.isMobile) {
        return;
      }

      // 700 是刚好让tab组件处于一个页面的可视区域中间的位置
      document.body.scrollTop = document.documentElement.scrollTop = 760;
    },
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
